module.exports = __webpack_public_path__ + "img/w22.3813a7f7.png";